export const getDisplayBreadcrumb = (petName: string) => {
  const breadcrumbNameMaxLength = 14; // TODO replace with backend short name https://chewyinc.atlassian.net/browse/PPB-820
  return petName.length <= breadcrumbNameMaxLength ? `${petName}'s Profile` : 'Pet Profile';
};
